import {Component} from '@angular/core';

@Component({
    templateUrl: './geen-toegang.page.component.html',
    styleUrls: ['./geen-toegang.page.component.scss'],
    standalone: false
})
export class GeenToegangPage {
}
